export const getApiErrorMessage = (error: any, locale: string, defaultMessage: string): string => {
  const verbose = error?.data?.verbose;
  if (verbose && typeof verbose === 'object' && verbose[locale]) {
    return verbose[locale];
  }
  return defaultMessage;
};
